import type { NotificationProps } from '@/core/components/notification/notification';

import { atom, useAtom } from '@/core/features/store/atom-store';

type NotificationStateProps = NotificationProps;

const notificationAtom = atom<NotificationStateProps | null>(null);

export const useNotification = () => useAtom(notificationAtom);
